__turbopack_context__.v({
  "passport_donate_button": "PassportDonateButton-module-scss-module__23xEtq__passport_donate_button",
});
